<script lang="ts" setup>
import type { ContentTypeArticleStoryList } from '~~/types/storyblok/stories'

const props = defineProps<{ categorySlugs: string }>()

const route = useRoute()

const storyQuery = computed(() => ({
  content_type: 'ContentTypeArticle',
  starts_with: 'insights/article',
  per_page: 4,
  excluding_slugs: (route.params.slug as string[]).join('/'),
  filter_query: {
    category: {
      any_in_array: props.categorySlugs,
    },
  },
}))

const fetchData = async () => {
  const response = await useAsyncStoryblokStoryQuery(storyQuery.value)
  return response.value.data.stories as ContentTypeArticleStoryList
}

const fetchedArticles = ref(await fetchData())

watch(
  () => props.categorySlugs,
  async () => {
    fetchedArticles.value = await fetchData()
  },
  { deep: true }
)

const hasFetchedArticles = computed(() => {
  return fetchedArticles.value.length > 0
})
</script>

<template lang="pug">
div(
  v-if="hasFetchedArticles"
  class="w-full pt-0 px-18 md:px-36 -mt-48 md:pt-72 pb-36 xl:px-0 xl:-mt-144"
)
  ArticleShowcase(:fetched-articles="fetchedArticles")
</template>
